import { Modal } from 'antd';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import qs from 'qs';
import { registerEnterprise, searchEnterprise } from '../../api/constlink';
import EnterpriseSelectComponent from '../../components/auth/SelectEnterpriseComponent';
import { logoutUserAsync } from '../../modules/auth';

function EnterpriseSelectContainer({ history }: RouteComponentProps) {
  const { redirectUrl } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });
  const [enterprises, setEnterprises] = useState<any>([]);
  const dispatch = useDispatch();
  const _searchEnterprise = async (input: any) => {
    const data = await searchEnterprise(input.name);
    if (data.length === 0) Modal.warning({ content: '회사가 없습니다.' });
    setEnterprises(data);
  };

  const selectEnterprise = async (enterpriseId: number) => {
    await registerEnterprise(enterpriseId);
    if (redirectUrl) {
      Modal.success({
        title: '회사설정 완료',
        content: '회사설정을 완료 하였습니다.',
        onOk() {
          history.push(`/${redirectUrl}` as string);
        },
      });
    } else {
      Modal.success({
        title: '회사설정 완료',
        content:
          '회사설정을 완료 하였습니다. 아래 버튼을 클릭하여 로그인 하세요.',
        okText: '로그인 하기',
        onOk() {
          dispatch(logoutUserAsync.request(null, null));
          localStorage.setItem(process.env.REACT_APP_AUTH_TOKEN_NAME!, '');
          history.push('/login');
        },
      });
    }
  };

  const moveToCreatePage = () => {
    history.push(`create-enterprise?redirectUrl=${redirectUrl}`);
  };

  return (
    <>
      <EnterpriseSelectComponent
        searchEnterprise={_searchEnterprise}
        selectEnterprise={selectEnterprise}
        data={enterprises}
        moveToCreatePage={moveToCreatePage}
      />
    </>
  );
}

export default EnterpriseSelectContainer;
